import React from 'react';

function Configuration(props) {
    return (<></>);
}

export default Configuration;
